import { render, staticRenderFns } from "./MembersipChat.vue?vue&type=template&id=6c31854f&scoped=true"
import script from "./MembersipChat.vue?vue&type=script&lang=js"
export * from "./MembersipChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c31854f",
  null
  
)

export default component.exports